import moment from 'moment';
import type { Conversation } from './types';

export function sortConversations(list: Conversation[]): Conversation[] {
  return [...list].sort((a, b) => {
    const aTime = a.last_message_at ?? a.updated_at ?? '';
    const bTime = b.last_message_at ?? b.updated_at ?? '';
    return bTime.localeCompare(aTime);
  });
}

export function getConversationTitle(c: Conversation): string {
  return c.is_group ? c.name ?? 'Group chat' : c.other_username ?? 'Chat';
}

export function formatConversationTime(iso?: string | null): string {
  if (!iso) return '';
  const date = moment(iso);
  if (date.isSame(moment(), 'day')) return date.format('HH:mm');
  if (date.isSame(moment(), 'year')) return date.format('MMM D');
  return date.format('M/D/YY');
}

export function formatLastMessagePreview(
  conversation: Conversation,
  currentUserId?: number,
): string {
  const content = conversation.last_message_content?.trim();
  if (!content) return 'No messages yet';

  if (conversation.is_group) {
    if (conversation.last_message_sender_id === currentUserId) {
      return `You: ${content}`;
    }
    if (conversation.last_message_sender_name) {
      return `${conversation.last_message_sender_name}: ${content}`;
    }
  } else if (conversation.last_message_sender_id === currentUserId) {
    return `You: ${content}`;
  }

  return content;
}

export function mapLastMessageFromApi(messagesData: any[] | undefined | null) {
  const lastMsg = messagesData?.[0];
  if (!lastMsg) return null;

  const attrs = lastMsg.attributes ?? lastMsg;
  const sender = attrs.sender?.data;

  return {
    last_message_content: attrs.content ?? null,
    last_message_at: attrs.createdAt ?? null,
    last_message_sender_id: sender?.id ? Number(sender.id) : null,
    last_message_sender_name: sender?.attributes?.username ?? null,
  };
}
